type YYYY_MM_DD = `${1 | 2}${number}${number}${number}-${'0' | '1'}${number}-${'0' | '1' | '2' | '3'}${number}`;
type YYYY_MM = `${1 | 2}${number}${number}${number}-${'0' | '1'}${number}`;
type DD_MM_YYYY_DOT = `${'0' | '1' | '2' | '3'}${number}.${'0' | '1'}${number}.${1 | 2}${number}${number}${number}`;
type MM_YYYY_SLASH = `${'0' | '1'}${number}/${1 | 2}${number}${number}${number}`;
type DD_MM_YYYY_HH_MM_SS_DOT = `${DD_MM_YYYY_DOT} ${'0' | '1' | '2'}${number}:${
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'}${number}:${'0' | '1' | '2' | '3' | '4' | '5'}${number}`;

export const dateTo_yyyy_MM_dd = (date: Date | string): YYYY_MM_DD => {
    let originalDate: Date;
    if (typeof date === 'string') {
        originalDate = new Date(date);
    } else {
        originalDate = date;
    }
    const year = originalDate.getFullYear();
    const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
    const day = originalDate.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(formattedDate)) {
        throw new Error(`Invalid date format: ${formattedDate}`);
    }

    return formattedDate as YYYY_MM_DD;
};

export const dateTo_yyyy_MM = (date: Date | string): YYYY_MM => {
    let originalDate: Date;
    if (typeof date === 'string') {
        originalDate = new Date(date);
    } else {
        originalDate = date;
    }
    const year = originalDate.getFullYear();
    const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
    const formattedDate = `${year}-${month}`;

    const dateRegex = /^\d{4}-\d{2}$/;
    if (!dateRegex.test(formattedDate)) {
        throw new Error(`Invalid date format: ${formattedDate}`);
    }

    return formattedDate as YYYY_MM;
};

export const dateTo_DD_MM_YYYY_dot = (date: Date | string | null | undefined): DD_MM_YYYY_DOT | '' => {
    if (!date) return '';
    const originalDate = typeof date === 'string' ? new Date(date) : date;
    const day = originalDate.getDate().toString().padStart(2, '0');
    const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
    const year = originalDate.getFullYear();
    return `${day}.${month}.${year}` as DD_MM_YYYY_DOT;
};

export const dateTo_MM_YYYY_slash = (date: Date | null | undefined): MM_YYYY_SLASH | '' => {
    if (!date) return '';
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${year}` as MM_YYYY_SLASH;
};

export const dateTo_DD_MM_YYYY_HH_mm_ss_dot = (
    date: Date | string | null | undefined,
): DD_MM_YYYY_HH_MM_SS_DOT | '' => {
    if (!date) return '';
    const originalDate = typeof date === 'string' ? new Date(date) : date;
    const day = originalDate.getDate().toString().padStart(2, '0');
    const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
    const year = originalDate.getFullYear();
    const hours = originalDate.getHours().toString().padStart(2, '0');
    const minutes = originalDate.getMinutes().toString().padStart(2, '0');
    const seconds = originalDate.getSeconds().toString().padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}` as DD_MM_YYYY_HH_MM_SS_DOT;
};
